import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "d-flex align-center justify-start ml-5 mt-5" }
const _hoisted_3 = { style: {"white-space":"nowrap","overflow":"hidden"} }
const _hoisted_4 = { style: {"font-weight":"bold","font-size":"12pt","white-space":"nowrap","overflow":"hidden"} }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_card = _resolveComponent("oss-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.amountGiftWarning)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 0,
              class: "d-flex justify-center py-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: _ctx.$vuetify.display.mobile ? '12' : '12',
                  class: "my-0 pa-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: _ctx.$vuetify.display.mobile ? '12' : '1'
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                              _createVNode(_component_v_btn_back, {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["cols"]),
                        _createVNode(_component_v_col, {
                          cols: _ctx.$vuetify.display.mobile ? '12' : '10'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_oss_card, {
                              icon: '$fa-exclamation-triangle',
                              "icon-color": 'new_red'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { style: {} }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                                            _createElementVNode("span", {
                                              class: "d-flex align-center justify-center ml-5",
                                              style: {"font-weight":"bold","font-size":"12pt"}
                                            }, " Le prix de revient ou d'achat du cadeau offert est de 69 € TTC maximum par an et par bénéficiaire. ", -1),
                                            _createElementVNode("span", {
                                              class: "d-flex align-center justify-center ml-5",
                                              style: {"font-weight":"bold","font-size":"12pt"}
                                            }, [
                                              _createTextVNode(" Si les cadeaux clients déductibles atteignent 3 000€ par an, il ne faut surtout pas omettre de remplir la déclaration n°2067 (relevé des frais généraux "),
                                              _createElementVNode("br"),
                                              _createTextVNode(" pour les sociétés) ou le cadre F de la déclaration n°2031 (pour les entreprises individuelles) de la liasse fiscale. ")
                                            ], -1)
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["cols"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["cols"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
          return (_openBlock(), _createBlock(_component_v_row, {
            key: item.id,
            class: "d-flex justify-center py-1",
            style: {"height":"fit-content"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: _ctx.$vuetify.display.mobile ? '12' : '10',
                class: "pa-0 d-flex justify-center",
                onClick: ($event: any) => (_ctx.openDocument(item)),
                style: {"cursor":"pointer"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_card, {
                    icon: 'trending_down',
                    "icon-color": 'new_red',
                    "tag-text": _ctx.callToActionText(item),
                    "tag-style": 'elevation-0 pa-1 mr-2',
                    "outlined-tag": false,
                    amount: item.amount,
                    "amount-style": 
                            _ctx.$vuetify.display.mobile
                                ? 'font-weight-black align-center justify-center'
                                : 'title font-weight-black'
                        ,
                    "rounded-tag": "",
                    "onClick:tag": ($event: any) => (_ctx.openDocument(item))
                  }, {
                    left: _withCtx(() => [
                      (_ctx.$vuetify.display.mobile)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { class: "d-flex align-center primary--text pt-2 pl-2" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_3, _toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { class: "d-flex overline pb-2 pl-2" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", null, [
                                    _createVNode(_component_v_icon, {
                                      color: "secondary",
                                      size: "small",
                                      location: "start"
                                    }, {
                                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode("$oss-calendar")
                                      ])),
                                      _: 1
                                    }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.getDateFormated(item)), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_component_v_row, {
                            key: 1,
                            "no-gutters": "",
                            style: {"height":"fit-content"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { style: {} }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      (_ctx.checkAmountGiftWarning(item))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                            _createVNode(_component_v_icon, {
                                              size: "small",
                                              color: "new_red",
                                              left: ""
                                            }, {
                                              default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                _createTextVNode("$fa-exclamation-triangle")
                                              ])),
                                              _: 1
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_col, { style: {"max-width":"fit-content"} }, {
                                default: _withCtx(() => [
                                  (item.date)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                        _createVNode(_component_v_icon, {
                                          color: "secondary",
                                          size: "small",
                                          location: "start"
                                        }, {
                                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                                            _createTextVNode("$oss-calendar")
                                          ])),
                                          _: 1
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_ctx.getDateFormated(item)), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                    ]),
                    _: 2
                  }, 1032, ["tag-text", "amount", "amount-style", "onClick:tag"])
                ]),
                _: 2
              }, 1032, ["cols", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ]),
    _: 1
  }))
}